import { render, staticRenderFns } from "./AreaPath.vue?vue&type=template&id=2d5644ea&scoped=true&"
import script from "./AreaPath.vue?vue&type=script&lang=js&"
export * from "./AreaPath.vue?vue&type=script&lang=js&"
import style0 from "./AreaPath.vue?vue&type=style&index=0&id=2d5644ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5644ea",
  null
  
)

export default component.exports